
import _ from 'lodash';

window.addEventListener('load', () => {
    const header = sel('.desktop-header');
    const headerOffices = sel('.header-langs-diff');

    headerOffices.classList.add('header-anim');
    header.classList.add('header-anim');
    if (sel('.page-home')) {
        //del testing
        const topSection = sel('.page-home .top-section');
        const title = sel('.page-home .top-section .left-side .title');
        const caption = sel('.page-home .top-section .left-side .caption');

        caption.classList.add('caption-anim');
        title.classList.add('title-anim');
        topSection.classList.add('top-section-anim');

        if(sel('.hero-video-wrapper')){
            const video = sel('.hero-video-wrapper');
            video.classList.add('hero-video-anim');
        }
    }

    if (sel('.single-service') || sel('.page-contacts') || sel('.page-about') || sel('.page-people') || sel('.page-experience') || sel('.page-insights') || sel('.page-career') || sel('.page-tvarumas')) {
        const sectionInners = selAll('.top-section-inner .top-section-bg-wrapper');
        const titleText = selAll('.top-section-inner .top-block .title');
        const text = selAll('.top-section-inner .top-block .text p');

        sectionInners.forEach(val => {
            val.classList.add('animated');
        });

        titleText.forEach(val => {
            val.classList.add('animated');
        });

        text.forEach(val => {
            val.classList.add('animated');
        });

        if (sel('.people-main-section')) {
            const filterHead = selAll('.heading-title.sf-filter-block');

            filterHead.forEach(val => {
                val.classList.add('animated');
            });
        }

        if (sel('.heading-title.mob')) {
            const heading = selAll('.heading-title.mob');

            heading.forEach(val => {
                val.classList.add('animated');
            });
        }
    }
});